import { render, staticRenderFns } from "./UserFormV2.vue?vue&type=template&id=068c86a1&"
import script from "./UserFormV2.vue?vue&type=script&lang=js&"
export * from "./UserFormV2.vue?vue&type=script&lang=js&"
import style0 from "./UserFormV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports